module.exports = __webpack_public_path__ + "static/img/ancmt-sticky.fa3e9c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ancmt-sticky.png
// module id = TRiq
// module chunks = 2